export default "__VITE_ASSET__2ef55737__"